module.exports = __webpack_public_path__ + "static/media/palm-springs.670c7fa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightBrowse/img/destinations/palm-springs.jpg
// module id = 1038
// module chunks = 0